import { Link } from "react-router-dom";
import { MessageCircle, Instagram, Mail, Phone } from "lucide-react";
import { CONTACT, PUBLIC_CENTRES, TRIAL_WA } from "../data/content";

const scrollTo = (hash) => {
  const el = document.querySelector(hash);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Footer = () => (
  <footer className="bg-black border-t border-white/8 pt-16 pb-8" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-12">
      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-14">
        {/* Brand */}
        <div className="lg:col-span-1">
          <Link to="/" className="flex items-center gap-1 mb-5" data-testid="footer-logo">
            <img src="/logo.png" alt="Zavi Football Club" className="h-14 w-auto" />
            <p className="font-heading text-2xl font-black tracking-tighter leading-none">
              ZAVI<span className="text-[#D4AF37]">FC</span>
            </p>
          </Link>
          <p className="font-heading text-xs uppercase tracking-[0.25em] text-[#D4AF37] font-bold">Disrupt · Dominate · Decide</p>
          <p className="text-white/50 text-sm mt-4 leading-relaxed">Premium football development for players aged 5–18 in Faridabad.</p>
        </div>

        {/* Explore */}
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-bold mb-4">Explore</p>
          <ul className="space-y-2.5 text-sm">
            {[
              ["#why-zavi", "Why Zavi"],
              ["#training-groups", "Training Groups"],
              ["#pathway", "Player Pathway"],
              ["#centres", "Our Centres"],
              ["#reviews", "Google Reviews"],
              ["#contact", "Contact"],
            ].map(([hash, label]) => (
              <li key={hash}>
                <button onClick={() => scrollTo(hash)}
                  className="text-white/60 hover:text-[#D4AF37] transition-colors duration-200"
                  data-testid={`footer-link-${hash.slice(1)}`}>{label}</button>
              </li>
            ))}
          </ul>
        </div>

        {/* Centres */}
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-bold mb-4">Training Centres</p>
          <ul className="space-y-4 text-sm">
            {PUBLIC_CENTRES.map((c) => (
              <li key={c.id}>
                <p className="text-white font-semibold text-sm">{c.school}</p>
                <p className="text-white/50 text-xs mt-0.5">{c.sector} · {c.city}</p>
                <a href={c.map} target="_blank" rel="noreferrer"
                  className="text-[#D4AF37] text-xs uppercase tracking-widest hover:underline"
                  data-testid={`footer-map-${c.id}`}>View on map →</a>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div>
          <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 font-bold mb-4">Contact</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#D4AF37]"
                data-testid="footer-whatsapp">
                <MessageCircle size={14} /> WhatsApp
              </a>
            </li>
            <li>
              <a href={`tel:${CONTACT.phoneRaw}`} className="flex items-center gap-2 text-white/70 hover:text-[#D4AF37]" data-testid="footer-phone">
                <Phone size={14} /> {CONTACT.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 text-white/70 hover:text-[#D4AF37]" data-testid="footer-email">
                <Mail size={14} /> {CONTACT.email}
              </a>
            </li>
            <li>
              <a href={CONTACT.instagram} target="_blank" rel="noreferrer"
                className="flex items-center gap-2 text-white/70 hover:text-[#D4AF37]"
                data-testid="footer-instagram">
                <Instagram size={14} /> @{CONTACT.instagramHandle}
              </a>
            </li>
            <li className="pt-3">
              <a href={TRIAL_WA} target="_blank" rel="noreferrer"
                className="inline-block bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-xs px-4 py-2.5 hover:bg-[#F3D059]"
                data-testid="footer-trial">Book a Free Trial</a>
            </li>
            <li className="pt-1">
              <Link to="/login" className="text-white/50 text-xs uppercase tracking-widest hover:text-[#D4AF37]" data-testid="footer-login">Player Login →</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-14 pt-6 border-t border-white/8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/40">
        <p>© 2026 Zavi Football Club. All rights reserved.</p>
        <p className="uppercase tracking-widest">Faridabad · India</p>
      </div>
    </div>
  </footer>
);
